var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as ActionTypes from '../actions/betradar';
var initialState = {
    showStream: false,
    streamUrl: null,
};
export default function betradarReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case ActionTypes.FETCH_BETRADAR_STREAM:
            return __assign(__assign({}, state), { streamUrl: null });
        case ActionTypes.SUCCESS_FETCH_BETRADAR_STREAM:
            return __assign(__assign({}, state), { streamUrl: action.data });
        case ActionTypes.FAILURE_FETCH_BETRADAR_STREAM:
            return __assign(__assign({}, state), { streamUrl: null });
        case ActionTypes.TOGGLE_STREAM:
            return __assign(__assign({}, state), { showStream: !state.showStream });
        case ActionTypes.RESET_BETRADAR:
            return initialState;
        default:
            return state;
    }
}
;



// WEBPACK FOOTER //
// ./src/reducers/betradarReducer.js